


































































import Vue from 'vue';

import NumberPads from '@/components/Money/numberPads.vue';
import Types from '@/components/Types.vue';
import FormItem from '@/components/Money/FormItem.vue';
import Tags from '@/components/Money/tags.vue';
import {Component} from 'vue-property-decorator';
import Record from '@/components/Record.vue';
import Card from '@/components/Card.vue';
import {ALL_CATEGORIES, DEFAULT_EXPENSE_CATEGORIES, DEFAULT_INCOME_CATEGORIES} from '@/lib/data';
import SelectMonth from '@/components/SelectMonth.vue';
import dayjs from 'dayjs';
import clone from '@/lib/clone';


@Component({
    components: {
        SelectMonth,
        Record,
        Card,
        Types, FormItem, Tags, NumberPads
    }
})
export default class extends Vue {
    RecordToggle = false; //这是控制记账页面的toggle
    TypesToggle = false; //这是类型控制
    MonthToggle = false; //这是月份控制
    dataIncome = DEFAULT_INCOME_CATEGORIES;
    dataExpense = DEFAULT_EXPENSE_CATEGORIES;
    SelectMonth = dayjs().month(dayjs(new Date()).month());
    SelectedTypeName = '全部类型';
    SelectedType='+';
    WeekList = {
        Sunday: '星期日',
        Monday: '星期一',
        Tuesday: '星期二',
        Wednesday: '星期三',
        Thursday: '星期四',
        Friday: '星期五',
        Saturday: '星期六'

    };

    get IncomeTotal() {
        const xxx: number = this.RecordListDay.reduce((sum, b) => {
            return sum + b.income;
        }, 0);
        return xxx;
    }

    get ExpenseTotal() {
        const xxx: number = this.RecordListDay.reduce((sum, b) => {
            return sum + b.expense;
        }, 0);
        return xxx;
    }

    get RecordList(): RecordItem[] {
        return this.$store.state.RecordList;
    }


    get RecordListMonth(): RecordItem[] {   //过滤所选月份
        return this.RecordList.filter(item => {
            return this.SelectMonth.month() === dayjs(item.date).month();

        }).sort((a, b) => {
            return dayjs(b.date).valueOf() - dayjs(a.date).valueOf();
        });
    }

    get RecordListDay() {  //对每个月进行排序
        const newList = clone(this.RecordListMonth);

        if (newList.length > 0) {
            const result: Result = [{
                day: dayjs(newList[0].date).format('dddd'),
                title: dayjs(newList[0].date).format('MM-DD'),
                item: [newList[0]],
                expense: 0,
                income: 0

            }];
            for (let i = 1; i < newList.length; i++) {
                const current = newList[i];
                const last = result[result.length - 1];
                if (dayjs(current.date).isSame(dayjs(last.item[0].date), 'day')) {
                    last.item.push(current);
                } else {
                    result.push({
                        day: dayjs(current.date).format('dddd'),
                        title: dayjs(current.date).format('MM-DD'),
                        item: [current],
                        income: 0,
                        expense: 0
                    });
                }
            }
            result.map(group => {
                group.income = group.item.reduce((sum, b) => {
                    return b.type === '+' ? sum + b.amount : sum;
                }, 0);
            });
            result.map(group => {
                group.expense = group.item.reduce((sum, b) => {
                    return b.type === '-' ? sum + b.amount : sum;
                }, 0);
            });
            return result;

        } else {
            return [];
        }

    }

    changeMonthToggle() {
        this.MonthToggle = true;
    }

    get Month() {
        return dayjs(this.SelectMonth).format('YYYY年MM月');
    }

    created() {
        this.$store.commit('fetchRecords');

    }

    open() {
        this.RecordToggle = true;
    }

    changeTypesToggle() {
        this.TypesToggle = true;
    }

    getTime(value: RecordItem) {
        return dayjs(value.date).format('HH:MM');
    }

    record: RecordItem = {
        notes: '',
        tags: [],
        type: '-',
        amount: 0,
        id: 0
    };

    onUpdateNotes(value: string) {
        this.record.notes = value;

    }

    onUpdateTags(value: Tag[]) {
        this.record.tags = value;
    }

    saveRecord() {
        this.$store.commit('createRecord', this.record);
        this.record.notes = '';
        this.record.amount = 0;


    }


}

